<template lang="pug">
v-row
  v-col.pb-0.pr-0(cols="12" md='6')
    v-dialog(v-model='isModalCambiosEnTicket'  max-width='500')
      v-card.pa-3
        .flex-1
          v-card-title.pa-3.pl-4
            span.font-weight-700 Cambios en el ticket
          v-card-subtitle.pb-3.font-size-13 Todos los procesos se aplicaran al numero de ticket
          .d-flex.pa-3.fd-column
            v-card.flex-1.mb-3.pa-4(color="background")
              p.mb-2.font-weight-700.primary--text Cambiar a un estado en especifico
              v-select(
                hide-details
                :items='estadosTicket'
                item-value="codigo"
                v-model="estadoTicket"
                item-text="descripcion"
                :loading="isLoadingEstadosACambiar"
                label='Seleccionar estado'
                dense=''
                solo=''
              )
              v-btn.mt-4(color='success' block  small @click="fetchCambiarEstadoTicket()" )
                span Guardar cambios
        v-card-actions.mt-8
          v-spacer
          v-btn.mr-1(color='primary' small @click="closeDialogCambiosTicket()" block )
            | regresar
    v-card.mx-auto(rounded="0")
      v-card-text.py-3
        .d-flex
          v-text-field.mr-4(label='Numero' v-model="numeroTicket" @keyup.enter="resetLogsData(), fetchTickets()" dense hide-details solo )
          v-select.mr-4( v-model="tipo" dense hide-details @change="resetLogsData(), fetchTickets()"  :items="['todos', 'garantia', 'incidencia con equipo', 'solicitud de insumo']" label='Tipo' solo)
      v-divider.pa-0.ma-0
    v-card.box-logs(rounded="0")
      v-list.py-0(
        dense
        v-infinite-scroll='fetchByScroll',
        infinite-scroll-disabled='disabledScrollExcecute',
        infinite-scroll-distance='2'
      )
        ticket-summary-info.animated.fadeInUp.faster(
          :key="index"
          v-for="(o, index) in lista"
          :ticket="o"
          :handler="true",
          @href="fetchLogs(o.numero, index)"
        )
  v-col.pb-0.pr-0.pl-0(cols="12" md='6' )
    v-card.mx-auto(rounded="0")
      v-card-text.py-3
        .d-flex.jc-center.ai-center
          span.font-weight-700.font-size-21.primary--text(v-if="indexSeleccionado !== ''")  {{`#${lista[indexSeleccionado].numero}`}}
          v-spacer
          span &nbsp;
          .d-flex(v-if="indexSeleccionado !== ''")
            v-btn.mr-4(small color='success' dark='' @click="openDialogCambiosTicket()" )
              | realizar cambios
          .d-flex
            v-select.mr-4( v-model="accion" @change="filtrarPorAccion" dense hide-details  :items="accionesActividades" label='Buscar por accion' solo)
      v-divider.pa-0.ma-0
    v-card.box-logs.elevation-1(:class="{'jc-center ai-center d-flex' : !logs.length}" rounded="0")
      v-card.elevation-0
        v-card-text
          div(v-if="logs.length")
            .font-weight-bold.ml-8.mb-2
              | Hoy
            v-timeline(align-top='' dense='')
              v-timeline-item.pb-4(v-for='(a, index) in logs' :key='index' color="primary" small='')
                div
                  .font-weight-normal
                    span.font-weight-700.font-size-12 {{ a.usuario }} &nbsp;
                    v-icon(size="13") access_time
                    small  {{ a.fecha | now}} - {{a.fecha | formatDate}}
                  v-menu(transition='slide-y-transition' bottom=''  :close-on-content-click="false" v-if="a.numeroActividad")
                    template(v-slot:activator='{ on, attrs }')
                      v-btn.mr-3(x-small='' color='info' dark='' @click="fetchActividad(a.numeroActividad)" v-bind='attrs' v-on='on')
                        v-icon.mr-1(size="14") visibility
                        | activ. ({{a.numeroActividad}})
                    span
                      v-progress-linear(v-if="isLoadingActividad" indeterminate color="primary")
                      item-actividad(:actividad="actividad",  is-log v-else)
                  span.font-weight-700.info--text.font-size-11 {{ a.accion }}
          .d-flex.fd-column.jc-center.ai-center.pa-6(v-else)
            v-icon(color="background", size="100") clear_all
            span.font-weight-700.primary--text
              | No existen logs para mostrar
            span.text-muted.font-size-12 Seleccione un ticket para obtener el listado de logs
</template>
<script>
import { apiGet, apiPost, notify } from '../util/general'
import itemTimeLine from '@/components/c_item_timeline'
import TicketSummaryInfo  from '@/components/c_item_ticket_lista'
import moment from 'moment'
export default {
  components : {
    'item-actividad'     : itemTimeLine,
    'ticket-summary-info': TicketSummaryInfo
  },
  data: () => ({
    numeroTicket            : '',
    selectedItem            : 1,
    lista                   : [],
    noMore                  : false,
    disabledScrollExcecute  : false,
    isScroll                : false,
    numeroRecnum            : 0,
    logs                    : [],
    filteredLogs            : [],
    actividad               : {},
    isLoadingActividad      : false,
    menu                    : false,
    isModalCambiosEnTicket  : false,
    indexSeleccionado       : '',
    tipo                    : 'todos',
    accionesActividades     : [],
    estadosTicket           : [],
    accion                  : '',
    isLoadingEstadosACambiar: false,
    estadoTicket            : ''

  }),
  created () {
    var vm = this
    vm.fetchTickets()
  },
  filters : {
    now: function (value) {
      if (!value) return ''
      return moment(value).fromNow()
    },
    formatDate: function (value) {
      if (!value) return ''
      return moment(value).format('DD/MM/YYYY HH:mm')
    }
  },
  methods : {
    openDialogCambiosTicket () {
      var vm = this
      vm.estadoTicket = ''
      vm.isModalCambiosEnTicket = true
      vm.fetchEstadosTicket()
    },
    closeDialogCambiosTicket () {
      var vm = this
      vm.isModalCambiosEnTicket = false
    },
    limpiarFiltros () {
      var vm = this
      vm.tipo = 'todos'
      vm.numeroTicket = ''
      vm.resetLogsData()
      vm.fetchTickets()
    },
    resetLogsData () {
      var vm = this
      vm.logs = []
      vm.filteredLogs = []
      vm.accion = ''
      vm.indexSeleccionado = ''
    },
    filtrarPorAccion () {
      var vm = this
      if (vm.accion !== 'Todos') {
        vm.logs = []
        for (var i = 0; i < vm.filteredLogs.length; i++) {
          var e = vm.filteredLogs[i];
          if (e.accion === vm.accion) vm.logs.push(e)
        }
      } else vm.logs = vm.filteredLogs
    },
    fetchByScroll () {
      var vm = this
      vm.isScroll = true
      vm.fetchTickets()
    },
    fetchLogs (numero, index) {
      var vm  = this
      vm.indexSeleccionado = index
      var url = '/auditoria/obtener'
      var obj = {
        numero : numero
      }
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo Logs' })
      apiGet(vm, url, obj, function (data) {
        vm.logs                = data.data.reverse()
        vm.filteredLogs         = vm.logs
        vm.accionesActividades = ['Todos']
        vm.accion              = 'Todos'
        for (var i = 0; i < vm.logs.length; i++) {
          if (!vm.accionesActividades.includes(vm.logs[i].accion)) vm.accionesActividades.push(vm.logs[i].accion)
        }
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchActividad (numero) {
      var vm  = this
      var url = '/auditoria/obtener/actividad'
      vm.isLoadingActividad = true
      var obj = {
        numeroActividad : numero
      }
      // vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo actividad del log' })
      apiGet(vm, url, obj, function (data) {
        vm.actividad = data.lista[0]
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        // vm.$store.dispatch('transaccion', { isProceso : false })
        vm.isLoadingActividad  = false
      })
    },
    fetchEstadosTicket () {
      var vm  = this
      var url = '/estado/obtener'
      vm.isLoadingEstadosACambiar = true
      var obj = {
        tipo : vm.lista[vm.indexSeleccionado].tipoticket
      }
      apiGet(vm, url, obj, function (data) {
        vm.estadosTicket = data.lista
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isLoadingEstadosACambiar  = false
      })
    },
    fetchCambiarEstadoTicket () {
      var vm  = this
      var url = '/ticket/cambiar/estado/sistemas'
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Cambiando estado de ticket' })
      var obj = {
        estado: vm.estadoTicket,
        numero: vm.lista[vm.indexSeleccionado].numero
      }
      apiPost(vm, url, obj, function (data) {
        notify(vm, 'success', 'Exito', 'Los cambios se realizaron con exito')
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchTickets () {
      var vm  = this
      var url = '/ticket/obtener'
      if (!vm.isScroll) {
        vm.lista = []
        vm.numeroRecnum = 0
      }
      vm.disabledScrollExcecute = true
      var tiposTicket = []
      if (vm.tipo === 'todos') tiposTicket.push('garantia', 'incidencia con equipo', 'solicitud de insumo')
      else tiposTicket.push(vm.tipo)

      var obj = {
        numero      : vm.numeroTicket,
        tipoTicket  : tiposTicket,
        numeroRecnum: vm.numeroRecnum,
        isLogs      : true
      }
      vm.noMore                 = false
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo Logs' })
      apiGet(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i])
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExcecute = true
        } else {
          vm.numeroRecnum = data.numeroRecnum
          vm.disabledScrollExcecute = false
        }
      }, function (err) {
        vm.disabledScrollExcecute = true
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isScroll  = false
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    }
  }
}
</script>
<style lang="stylus">
.box-logs
  height calc(100vh - 168px)
  overflow-y auto
.tr-selected
  // border-left: 6px solid #2d4258!important;
  background-color: rgba(45,66,88,.169) !important;
</style>




// WEBPACK FOOTER //
// View_auditoria.vue?2b2d0a44